import { Routes, Route } from 'react-router-dom';
import { AuthProvider } from '@/features/auth/context/AuthContext';
import { MuseumProvider } from '@/features/museum/context/MuseumContext';
import { NotificationProvider } from '@/shared/context/NotificationContext';
import { ProtectedRoute } from '@/features/auth/components/ProtectedRoute';
import { LoginPage } from '@/features/auth/pages/LoginPage';
import { DashboardLayout } from '@/shared/components/layout/DashboardLayout';
import { ExhibitionsPage } from '@/features/exhibitions/pages/ExhibitionsPage';
import { CreateExhibitionPage } from '@/features/exhibitions/pages/CreateExhibitionPage';
import { ExhibitionDetailPage } from '@/features/exhibitions/pages/ExhibitionDetailPage';
import { QrCodePage } from '@/features/qr/pages/QrCodePage';
import { ErrorBoundary } from '@/shared/components/ErrorBoundary';

function App() {
  return (
    <ErrorBoundary>
      <NotificationProvider>
        <AuthProvider>
          <MuseumProvider>
            <Routes>
          {/* Route sans slug pour le login global (optionnel) */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/qr-code" element={<QrCodePage />} />
          {/* Routes avec slug du musée */}
          <Route path="/:museumSlug/login" element={<LoginPage />} />
          <Route
            path="/:museumSlug/*"
            element={
              <ProtectedRoute>
                <DashboardLayout>
                  <Routes>
                    <Route path="" element={<ExhibitionsPage />} />
                    <Route path="exhibitions/new" element={<CreateExhibitionPage />} />
                    <Route path="exhibitions/:exhibitionId" element={<ExhibitionDetailPage />} />
                  </Routes>
                </DashboardLayout>
              </ProtectedRoute>
            }
          />
            </Routes>
          </MuseumProvider>
        </AuthProvider>
      </NotificationProvider>
    </ErrorBoundary>
  );
}

export default App;

